import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { IoCheckmark } from 'react-icons/io5';
import { useParams } from 'react-router-dom';
import { getCourseDetails } from '../api/api';
import { getImageFullUrl } from '../api/httpClient';
import PlaceholderImage from '../assets/images/placeholder.jpeg';
import EnrollForm from '../components/EnrollForm';

export default function CourseDetails() {
  const { courseId } = useParams();

  const [details, setDetails] = useState(null);

  const fetchCourseDetails = async () => {
    const { error, data } = await getCourseDetails(courseId);
    if (!error) {
      setDetails(data?.data);
    }
  };

  useEffect(() => {
    fetchCourseDetails();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {details?.courseDetail?.title || t('courseDetails')} -{' '}
          {t('emstellCourse')}
        </title>
      </Helmet>
      <div className="max-w-5xl mx-auto md:mt-5 top-0 px-4 md:min-h-[880px]">
        <div className="bg-white rounded-3xl p-3 md:p-6 md:py-2 grid grid-cols-1 md:grid-cols-2 gap-x-5 lg:gap-x-10 gap-y-5 shadow-md shadow-black/5 ">
          <div>
            <h2 className="text-xl font-medium text-primary-300 hidden md:block mt-4">
              {details?.courseDetail?.title}
            </h2>
            <div className=" justify-between lg:pr-5 hidden md:flex">
              {details?.courseDetail?.isFree && (
                <span className="text-md  font-semibold text-red-500">
                  Free
                </span>
              )}
              {!details?.courseDetail?.isFree && (
                <div>
                  <span className="line-through text-xs text-red-500 hidden md:block">
                    {details?.courseDetail?.discount &&
                      details?.courseDetail?.discount != 0 &&
                      `${parseFloat(details?.courseDetail?.fee || 0).toFixed(
                        3
                      )} KD`}
                  </span>
                  <div className="flex space-x-3 rtl:space-x-reverse items-center">
                    <span className="text-md text-primary-300 font-semibold">
                      {details?.courseDetail?.discountAmount &&
                        `${parseFloat(
                          details?.courseDetail?.discountAmount || 0
                        )?.toFixed(3)} KD`}
                    </span>
                    <span className="line-through text-xs text-red-500 block md:hidden">
                      {details?.courseDetail?.discount &&
                        details?.courseDetail?.discount != 0 &&
                        `${parseFloat(details?.courseDetail?.fee || 0).toFixed(
                          3
                        )} KD`}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="flex justify-center items-center  relative rounded-2xl ">
              <div className="overflow-hidden">
                {details?.courseDetail?.image && (
                  <img
                    src={getImageFullUrl(details?.courseDetail?.image)}
                    alt={details?.courseDetail?.title}
                    className="rounded-2xl md:mt-2"
                  />
                )}
              </div>
              <div className="absolute w-full px-4 py-3 bg-gradient-to-t from-black to-transparent left-0 bottom-0 block md:hidden">
                <div className="absolute justify-between lg:pr-5 flex md:hidden  right-4  -bottom-3 bg-white rounded-full px-2 py-0 border border-zinc-200">
                  {details?.courseDetail?.isFree && (
                    <span className="text-md  font-semibold text-red-500 ">
                      Free
                    </span>
                  )}
                  {!details?.courseDetail?.isFree && (
                    <div>
                      <span className="line-through text-xs text-red-500 hidden md:block">
                        {details?.courseDetail?.discount &&
                          details?.courseDetail?.discount != 0 &&
                          `${parseFloat(
                            details?.courseDetail?.fee || 0
                          ).toFixed(3)} KD`}
                      </span>
                      <div className="flex space-x-3 rtl:space-x-reverse items-center">
                        <span className="text-md text-primary-300 font-semibold">
                          {details?.courseDetail?.discountAmount &&
                            `${parseFloat(
                              details?.courseDetail?.discountAmount || 0
                            )?.toFixed(3)} KD`}
                        </span>
                        <span className="line-through text-xs text-red-500 block md:hidden">
                          {details?.courseDetail?.discount &&
                            details?.courseDetail?.discount != 0 &&
                            `${parseFloat(
                              details?.courseDetail?.fee || 0
                            ).toFixed(3)} KD`}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                <h2 className="text-xl font-medium text-white">
                  {details?.courseDetail?.title}
                </h2>
              </div>
            </div>
          </div>

          <div className="relative ">
            {/* title and pricing */}
            <div>
              {/* <h2 className="text-xl font-medium text-primary-300 hidden md:block">
                {details?.courseDetail?.title}
              </h2>
              <div className="flex justify-between lg:pr-5">
                {details?.courseDetail?.isFree && (
                  <span className="text-md  font-semibold text-red-500">
                    Free
                  </span>
                )}
                {!details?.courseDetail?.isFree && (
                  <div>
                    <span className="line-through text-xs text-red-500 hidden md:block">
                      {details?.courseDetail?.discount &&
                        details?.courseDetail?.discount != 0 &&
                        `${parseFloat(details?.courseDetail?.fee || 0).toFixed(
                          3
                        )} KD`}
                    </span>
                    <div className="flex space-x-3 rtl:space-x-reverse items-center">
                      <span className="text-md text-primary-300 font-semibold">
                        {details?.courseDetail?.discountAmount &&
                          `${parseFloat(
                            details?.courseDetail?.discountAmount || 0
                          )?.toFixed(3)} KD`}
                      </span>
                      <span className="line-through text-xs text-red-500 block md:hidden">
                        {details?.courseDetail?.discount &&
                          details?.courseDetail?.discount != 0 &&
                          `${parseFloat(
                            details?.courseDetail?.fee || 0
                          ).toFixed(3)} KD`}
                      </span>
                    </div>
                  </div>
                )}
              </div> */}
              <div className="block md:hidden">
                <div
                  className="text-sm font-normal text-gray-600  mt-1.5 mb-0 tracking-wide leading-[20px] summary"
                  dangerouslySetInnerHTML={{
                    __html: details?.courseDetail?.description,
                  }}
                />
              </div>
            </div>
            <div className="block md:absolute mt-2 sm:mt-5">
              <EnrollForm />
              <div className="clear-both"></div>
            </div>
          </div>

          <div className="hidden md:block">
            {/* <h4 className="font-semibold">{t('aboutThisCourse')}</h4> */}

            <div
              className="text-sm font-normal text-gray-600  mt-0 mb-0 tracking-wide leading-[20px] summary"
              dangerouslySetInnerHTML={{
                __html: details?.courseDetail?.description,
              }}
            />
            {/* <p className="text-sm font-normal text-gray-600  mt-0 mb-0 tracking-wide leading-[20px]">
              {details?.courseDetail?.description}
            </p> */}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 mt-4">
          {/* Summary */}
          <div>
            <div className="bg-gray-50 px-6 py-6 rounded-2xl">
              <h2 className="text-lg font-light text-primary-300">
                {t('summary')}
              </h2>
              <div
                className="summary"
                dangerouslySetInnerHTML={{
                  __html: details?.learnings?.[0]?.title,
                }}
              />
              {/* <ul className="space-y-5 mt-3">
                  {details?.learnings?.map((item, index) => {
                    return (
                      <li key={index} className="flex items-start space-x-2">
                        <span className="flex-shrink-0">
                          <IoCheckmark />
                        </span>
                        <span className="text-xs text-gray-600 leading-5">
                          {item?.title}
                          <div
                            dangerouslySetInnerHTML={{ __html: item?.title }}
                          />
                        </span>
                      </li>
                    );
                  })}
                </ul> */}
            </div>
          </div>
          {/* Pre Requirement */}
          <div>
            <div className="bg-gray-50 px-6 py-6 rounded-2xl">
              <h2 className="text-lg font-light text-primary-300">
                {t('preRequirement')}
              </h2>
              <ul className="space-y-5 mt-3">
                {details?.requirement?.map((item, index) => {
                  return (
                    <li key={index} className="flex items-start space-x-2">
                      <span className="flex-shrink-0">
                        <IoCheckmark />
                      </span>
                      <span className="text-xs text-gray-600 leading-5">
                        {item?.title}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
